export default __webpack_public_path__ + "images/pif-logo.png";